import React, {ComponentPropsWithoutRef} from 'react';
import classNames from 'classnames';

import './fieldset.scss';

const Fieldset = ({children, className}: ComponentPropsWithoutRef<'fieldset'>) => (
  <fieldset className={classNames('shared-fieldset', className)}>{children}</fieldset>
);

interface Props extends ComponentPropsWithoutRef<'legend'> {
  required?: boolean;
}

const Legend = ({children, className, required}: Props) => (
  <legend className={classNames('shared-fieldset-legend', className, {required})}>
    {children}
  </legend>
);

Fieldset.Legend = Legend;

export default Fieldset;
